<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="value"
        @input="v => $emit('input', v)"
        @click:clear="v => $emit('input', null)"
        :label="label"
        :prepend-icon="icon"
        :prepend-inner-icon="innerIcon"
        readonly
        :clearable="clearable"
        :rules="rules"
        :outlined="outlined"
        :hide-details="hideDetails"
        :solo="solo"
        :flat="flat"
        :solo-inverted="soloInverted"
        :filled="filled"
        :dense="dense"
        :single-line="singleLine"
        :class="{ 'no-before': filled }"
        :disabled="disabled"
        v-on="readonly ? false : on"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="value"
      @change="v => $emit('input', v)"
      @input="menu = false"
      no-title
      scrollable
      :allowed-dates="allowedDates"
      :first-day-of-week="firstDayOfWeek"
      :type="month ? 'month' : 'date'"
      :min="min"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
export default {
  name: "DatePicker",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    icon: {
      type: String,
      default: "fa-calendar"
    },
    required: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    allowedDates: {
      default: null
    },
    firstDayOfWeek: {
      default: 0
    },
    month: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    solo: {
      type: Boolean,
      default: false
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    innerIcon: {
      type: String,
      default: ""
    },
    min: {
      type: String,
      default: undefined
    },
    max: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rules() {
      const rules = [];
      if (this.required === true) {
        rules.push(v => !!v || `${this.label} est requis`);
      }
      if (this.min !== undefined && this.required === false) {
        rules.push(
          v =>
            moment(v).isSameOrAfter(moment(this.min)) ||
            v === null ||
            `La date doit être supérieure à ${moment(this.min).format("ll")}`
        );
      } else if (this.min !== undefined && this.required === true) {
        rules.push(
          v =>
            moment(v).isSameOrAfter(moment(this.min)) ||
            `La date doit être supérieure à ${moment(this.min).format("ll")}`
        );
      }
      return rules;
    }
  },
  data() {
    return {
      menu: false
    };
  }
};
</script>

<style></style>
